module.exports = Promise.all([__parcel__import__("duLj1"), __parcel__import__("6r35s")]).then(() => parcelRequire('4MH6n'));